import React from 'react'
import 'react-app-polyfill/ie9'
import 'react-app-polyfill/stable'
import { CookiesProvider } from 'react-cookie'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import store from './common/store'
import App from './components/App'
import { BASE_NAME } from './environment'

import './index.css'

ReactDOM.render(
  <CookiesProvider>
    <Provider store={store}>
      <BrowserRouter basename={BASE_NAME}>
        <App/>
      </BrowserRouter>
    </Provider>
  </CookiesProvider>,
  document.getElementById('root'),
)